const API = {
	TOKEN: {
		ACCESS: `api/token/`,
		REFRESH: `api/token/refresh/`
	},
	ROLES: {
		INDEX: `roles/`
	},
	GI_DATA: {
		GI_DATA_UPLOAD_COLLECTIONS: {
			INDEX: `gi_data_upload_collection/`
		},
		GI_POINTS: {
			INDEX: `gi_point_altered/`
		}
	},
	GI_DATA_UPLOAD_COLLECTIONS: {
		INDEX: `gi_data_upload_collection/`,
		CREATE_OPEN_GROUND: `gi_data_upload_collection/create_open_ground/`,
		UPDATE_OPEN_GROUND: (id: number) =>
			`gi_data_upload_collection/${id}/update_open_ground/`,
		IMPORT_FROM_SPECKLE: `gi_data_upload_collection/import-speckle/`,
		TASK_STATUS: (taskId: string) => `gi_data_upload_collection/task-status/${taskId}/`
	},
	OPENGROUND: {
		PROJECT_METADATA: `gi_data/openground/project_metadata/`,
		ACCESS_TOKEN: `gi_data/openground/access_token/`,
		GI_LOCATIONS: `gi_data/openground/gi_locations/`,
		EXPORT_TO_SPECKLE: `gi_data/openground/export_to_speckle/`,
		TASK_STATUS: (taskId: string) => `gi_data/openground/task-status/${taskId}/`
	},
	CALCULATION: {
		BASE: `calculation/`,
		PROCESS: 'calculation_process/'
	},
	CALCULATION_CPT: {
		BASE: `calculation_cpt/`,
		REPORT: `calculation_cpt/export_to_pdf`,
		EXCEL: (id: number) => `calculation_cpt/${id}/export_to_excel`
	},
	CPT: {
		BASE: `cpt/`
	},
	CORE: {
		PROJECTS: 'projects/',
		CALCULATION_PARAMETERS: 'calculation_parameters/',
		PROJECT_PARAMETER: 'project_parameters/',
		PROJECT_USERS: {
			INDEX: `project_users/`
		},
		USERS: {
			INDEX: `users/`,
			CURRENT_USER: `users/current_user/`
		}
	}
}

export default API
